import { render, staticRenderFns } from "./disposablePassword.vue?vue&type=template&id=20857dd6&"
import script from "./disposablePassword.vue?vue&type=script&lang=js&"
export * from "./disposablePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports